<template>
  <div class="d-flex flex-column align-center pt-12">
    <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      class="buttonText mt-12"
      @click="$router.push('/admin/newCompany')"
    >Create Company</v-btn>

    <div class="d-flex flex-column align-center mt-auto">
      <div class="subtitle-1 font-weight-bold mb-2">Partner of:</div>
      <div class="d-flex logos">
        <!-- <a href="https://cellex.gr/" target="_blank">
          <img src="@/assets/cellex.png" />
        </a> -->
        <img src="@/assets/brainz.png" />
      </div>
    </div>

    <div class="d-flex flex-column align-center dn2me-logo mt-5">
      <div class="subtitle-1 font-weight-bold mb-2">Powered by:</div>
      <img src="@/assets/authHeader.png" />
    </div>
  </div>
</template>

<script>
export default {};
</script>